import get from 'lodash/get'

export const formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber && phoneNumber.length === 10) {
        return '(' + phoneNumber.substring(0, 3) + ') ' + phoneNumber.substring(3, 6) + "-" + phoneNumber.substring(6, 10);
    }
    return phoneNumber;
}

export const formatPhoneNumberWithoutBracket = (phoneNumber) => {
    if (phoneNumber && phoneNumber.length === 10) {
        return phoneNumber.substring(0, 3) + ' ' + phoneNumber.substring(3, 6) + "-" + phoneNumber.substring(6, 10);
    }
    return phoneNumber;
}

export const getUnderwriterInfo = (user, isLoggedUser) => {
    const name = get(user, 'firstName', '') + ' ' + get(user, 'lastName', '');
    const email = get(user, 'email', '');
    const phone = get(user, 'phone', '');
    let phoneExt = get(user, 'phoneExt', '');
    if (phoneExt && phoneExt.trim() !== '') {
        phoneExt = '+' + phoneExt;
    }
    let title = get(user, 'title', 'Underwriter');
    if (title && title.trim() === '') {
        title = 'Underwriter';
    }
    return {
        name,
        email,
        phone,
        phoneExt,
        title,
        isLoggedUser
    }
}